import { Action, createReducer, on } from '@ngrx/store';
import * as CoreActions from './actions/core.actions';
import * as MessageHubActions from './actions/message-hub.actions';
import { CoreState, initialState } from './core.state';

const reducer = createReducer<CoreState>(
    initialState,
    on(CoreActions.loadAvailableActiveBranches,
        (state, action): CoreState => (
            {
                ...state,
                availableActiveBranches: action.payload.availableActiveBranches
            }
        )),
    on(CoreActions.promptUserToSignin,
        (state, action): CoreState => (
            {
                ...state,
                PromptSigningPopup: true,
                lobbySelectorChange: action.payload.isSelectorChange
            }
        )),
    on(CoreActions.promptUnableToSignin,
        (state): CoreState => (
            {
                ...state,
                UnableToSigningPopup: true
            }
        )),
    on(CoreActions.closeUnableToSigninPopup,
        (state): CoreState => (
            {
                ...state,
                UnableToSigningPopup: false
            }
        )),
    on(CoreActions.closeUserSigninPrompt,
        (state): CoreState => (
            {
                ...state,
                PromptSigningPopup: false
            }
        )),
    on(CoreActions.closeUnableToCheckinPopup,
        (state): CoreState => (
            {
                ...state,
                UnableToCheckInPopup: false
            }
        )),
    on(CoreActions.promptUnableToCheckin,
        (state): CoreState => (
            {
                ...state,
                UnableToCheckInPopup: true
            }
        )),
    on(CoreActions.updateUserSigninStatus,
        (state, action): CoreState => (
            {
                ...state,
                UserSignedInStatus: action.payload.status,
                CurrentAssistingLobbyEntryId: action.payload.CurrentAssistingLobbyEntryId
            }
        )),
    on(CoreActions.updateUserInfo,
        (state, action): CoreState => (
            {
                ...state,
                userInfo: action.payload.info
            }
        )),
    on(CoreActions.updateLocationSelectorInfo,
        (state, action): CoreState => (
            {
                ...state,
                LocationSelectorInfo: action.payload.locationSelectorInfo
            }
        )),
    on(CoreActions.updateLobbyLocationSelectorInfo,
        (state, action): CoreState => (
            {
                ...state,
                LobbyLocationSelectorInfo: action.payload.lobbyLocationSelectorInfo
            }
        )),
    on(CoreActions.updateACLocationSelectorInfo,
        (state, action): CoreState => (
            {
                ...state,
                ACLocationCode: action.payload.acLocationCode
            }
        )),
    on(CoreActions.updateUrlCode,
        (state, action): CoreState => (
            {
                ...state,
                urlCode: action.payload.urlCode
            }
        )),
    on(MessageHubActions.receivedUserSignedInStatus,
        (state, action): CoreState => (
            {
                ...state,
                UserSignedInStatus: action.messageData === '' ? null : JSON.parse(action.messageData)
            }
        )),
    on(MessageHubActions.receivedLobbyLocationSelectorStatus,
        (state, action): CoreState => (
            {
                ...state,
                locationSelectorStatus: action.messageData === '' ? null : JSON.parse(action.messageData)
            }
        )),
    on(CoreActions.updateAvailableTenants,
        (state, action): CoreState => (
            {
                ...state,
                availableTenants: action.payload.tenants
            }
        )),
    on(MessageHubActions.receivedSystemConfigurationData,
        (state, action): CoreState => (
            {
                ...state,
                systemConfigurations: action.payload.systemConfigurations,
                systemConfigLoaded: true
            }
        )),
    on(CoreActions.loadSystemConfigurationApiSuccess,
        (state, action): CoreState => (
            {
                ...state,
                systemConfigurations: action.payload.systemConfigurations,
                systemConfigLoaded: true
            }
        )),
    on(CoreActions.updateACClientConfiguration,
        (state, action): CoreState => (
            {
                ...state,
                acClientConfiguration: action.payload.acClientConfiguration
            }
        )),
    on(CoreActions.updateTenantLogo,
        (state, action): CoreState => (
            {
                ...state,
                tenantLogo: action.payload.tenantLogoUrl
            }
        )),
    on(MessageHubActions.receivedSyncStatus,
        (state, action): CoreState => (
            {
                ...state,
                syncStatus: (action.messageData != null) ? JSON.parse(action.messageData) : []
            }
        )),
    on(MessageHubActions.receivedClientCreateStatus,
        (state, action): CoreState => (
            {
                ...state,
                clientCreationStatus: action.messageData
            }
        )),
    on(CoreActions.ClearCreateClientStatus,
        (state): CoreState => (
            {
                ...state,
                clientCreationStatus: ''
            }
        )),

);

export function coreReducer(state: CoreState | undefined, action: Action) {
    return reducer(state, action);
}
